<template>
  <div>
    <!-- Filters -->
    <v-layout row justify-end wrap class="mb-5">
      <v-flex xs12 md6>
        <div class="ml-3">
          <v-text-field
            v-model="filters.search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <!-- Data table with invoices -->
    <v-data-table
      ref="openBillingContactTable"
      v-model="selectedItems"
      :loading="loading"
      :headers="headers"
      :items="contacts"
      :pagination.sync="contactsPagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="contactsPagination.totalItems"
      select-all
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          {{ $t('No hay información que mostrar con los filtros seleccionados :(') }}
        </v-alert>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th v-if="props.headers.length > 0" class="text-xs-center">
            <v-checkbox
              v-model="selectAllRows"
              @change="selectAllTableRows()"
              primary
              hide-details
            ></v-checkbox>
          </th>
          <template v-for="header in props.headers">
            <th
              :key="`th_${header.value}`"
              :class="[
                'text-xs-center',
                header.sortable ? 'column sortable' : '',
                contactsPagination.descending ? 'desc' : 'asc',
                header.value === contactsPagination.sortBy ? 'active' : '',
              ]"
              @click="header.sortable ? changeSort(header.value) : null"
            >
              <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </template>
          <th v-if="props.headers.length > 0" class="text-xs-center">ACCIONES</th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td>
            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td v-for="header in headers" :key="header.value" class="text-xs-center">
            {{ props.item[header.value] }}
          </td>
          <td class="text-xs-center">
            <v-icon small class="mr-2" @click="editContact(props.item)">
              edit
            </v-icon>
            <v-icon small @click="deleteContact(props.item)">
              delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';

export default {
  name: 'OpenBillingContactTable',
  components: {},
  props: [],
  data() {
    return {
      contacts: [],
      selectedItems: [],
      selectAllRows: false,
      loading: false,
      headers: [],
      contactsPagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      filters: {
        search: '',
      },
      sortTable: false,
    };
  },
  mounted() {
    this.getBillingContacts();
  },
  computed: {
    currentPage() {
      return this.contactsPagination.page;
    },
    perPage() {
      return this.contactsPagination.rowsPerPage;
    },
    sortBy() {
      return this.contactsPagination.sortBy;
    },
    descending() {
      return this.contactsPagination.descending;
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
    search() {
      return this.filters.search;
    },
  },
  methods: {
    getBillingContacts() {
      this.loading = true;
      const config = {
        params: {
          page: this.contactsPagination.page,
          per_page: this.contactsPagination.rowsPerPage,
          sort_by: this.contactsPagination.sortBy,
          descending: this.contactsPagination.descending,
          search: this.filters.search,
        },
      };
      apiCtrl
        .get(`/openbilling/${this.clavedat}/contacts/${this.billingProfileId}/list`, config)
        .then(res => {
          this.contacts = res.data.data;
          this.headers = res.data.dataTable.headers;
          this.contactsPagination = {
            descending: this.contactsPagination.descending,
            page: this.contactsPagination.page,
            rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
            sortBy: this.contactsPagination.sortBy,
            totalItems: Number(res.data.meta.total),
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selectAllTableRows() {
      if (
        this.selectedItems.length === 0 ||
        (this.selectedItems.length >= 1 && this.selectedItems.length < this.contacts.length)
      ) {
        let selected = [];
        this.contacts.forEach(item => {
          selected.push(item);
        });
        this.selectedItems = selected;
      } else if (this.selectedItems.length === this.contacts.length) {
        if (this.selectAllRows) {
          this.selectedItems = this.contacts;
        } else {
          this.selectedItems = [];
        }
      }
    },
    changeSort(column) {
      if (this.contactsPagination.sortBy === column) {
        this.contactsPagination.descending = !this.contactsPagination.descending;
      } else {
        this.contactsPagination.sortBy = column;
        this.contactsPagination.descending = false;
      }
    },
    editContact(contact) {
      this.$emit('on-edit-contact', contact);
    },
    deleteContact(contact) {
      this.$emit('on-delete-contact', contact);
    },
    getBillingContactsIfStopChanges() {
      this.loading = true;
      const params = {
        page: this.contactsPagination.page,
        per_page: this.contactsPagination.rowsPerPage,
        search: this.filters.search,
      };

      setTimeout(() => {
        if (
          params.page === this.contactsPagination.page &&
          params.per_page === this.contactsPagination.rowsPerPage &&
          params.search === this.filters.search
        ) {
          this.getBillingContacts();
        }
      }, 300);
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getBillingContactsIfStopChanges();
      } else {
        this.contactsPagination.page = 1;
      }
    },
    currentPage: function() {
      this.getBillingContactsIfStopChanges();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getBillingContactsIfStopChanges();
      } else {
        this.contactsPagination.page = 1;
      }
    },
    sortBy: function() {
      if (this.sortBy != null && this.sortTable) {
        this.getBillingContacts();
      } else {
        if (this.descending === null) {
          this.sortTable = false;
        }
      }
    },
    descending: function() {
      if (this.descending != null) {
        this.getBillingContacts();
        this.sortTable = true;
      } else {
        if (this.sortBy === null) {
          this.sortTable = false;
        }
      }
    },
    selectedItems: function() {
      this.$emit('on-selected-items', this.selectedItems);
    },
  },
};
</script>

<style scoped></style>
